module.exports = __webpack_public_path__ + "img/ignitionOff.8280e7aa.svg";